import { logger } from '../../utils/logger'
import { IFormattedSystemsForPostRequest, DownloadsData } from '../../domain/downloads.types'
import { EQUIPMENT_TYPE_LABEL } from '../../domain/enums/downloads.enums'
import { APP_PATH } from '../../ui/enums/appPath.enum'
import { useFetchApi } from '../../adapter/fetchApi'

export const useDownloadsApi = () => {
  const fetchApi = useFetchApi()
  return {
    getPowerPlantSystems: async (powerPlantId: number): Promise<DownloadsData[]> => {
      const requestedEquipmentTypes = [
        EQUIPMENT_TYPE_LABEL.COMPTEUR,
        EQUIPMENT_TYPE_LABEL.METEO,
        EQUIPMENT_TYPE_LABEL.CAPTEUR,
        EQUIPMENT_TYPE_LABEL.INVERTER,
        EQUIPMENT_TYPE_LABEL.SISENSOR,
        EQUIPMENT_TYPE_LABEL.HYGROMETER,
        EQUIPMENT_TYPE_LABEL.TEMPSENSOR,
        EQUIPMENT_TYPE_LABEL.PYRANOMETER,
        EQUIPMENT_TYPE_LABEL.METER,
      ].join(',')

      const url = `${APP_PATH.EQUIPMENTS}/${powerPlantId}?equipmentTypes=${requestedEquipmentTypes}`
      try {
        const data = await fetchApi<DownloadsData[]>(url)

        if (!data) {
          throw new Error(`getPowerPlantSystems - Error : ${data}`)
        }

        return data as DownloadsData[]
      } catch (error) {
        logger.error((error as Error).message)
        throw error
      }
    },
    exportPowerPlantSystemsData: async (
      powerPlantId: number,
      startDate: string,
      endDate: string,
      systems: IFormattedSystemsForPostRequest
    ): Promise<Blob> => {
      const url = `${APP_PATH.POWER_PLANT_EXPORT_DATA}/${powerPlantId}`
      const requestData = { startDate, endDate, systems }
      const config = { method: 'POST', body: requestData }

      try {
        const response = await fetchApi<Blob>(url, config, 'blob')

        if (!response) {
          throw new Error(`exportPowerPlantSystemsData - Error: ${response}`)
        }

        return response
      } catch (error) {
        logger.error((error as Error).message)
        throw error
      }
    },
  }
}
